
<div *ngIf="!test" class="outside-container " >
    <div >
        <div class="container">
          <div  class="stepper-container">
            <div class="steps">
              
              <div class="step"  [class.active]="currentStep === 1"><mat-icon style="font-size:17px; padding-top: 8px;">payments</mat-icon>Payment & Booking</div>
              <div class="step" [class.active]="currentStep === 2"> <mat-icon style="font-size: 17px;padding-top: 8px;">book</mat-icon>Ticket Detail</div>
              <!-- <div class="step" [class.active]="currentStep === 3"><mat-icon style="font-size: 17px; padding-top: 8px;">print</mat-icon>Print Detail</div> -->
            </div>
          
            <div class="step-content">
              <!-- Content for each step goes here -->
              <!-- <div *ngIf="currentStep === 1">Payment Detail Content</div>
              <div *ngIf="currentStep === 2">Booking Content</div>
              <div *ngIf="currentStep === 3">Print Detail Content</div> -->

              <div class="col-md-12">
                <form >
                  <!-- <mat-form-field>
                    <mat-label>Name</mat-label>
                    <input matInput placeholder="Last name, First name" formControlName="firstCtrl" required>
                  </mat-form-field>  -->
                  <div *ngIf="showNext && pnrData && currentStep===2" class="box-container mb-4">
              
                    <div class="container">
                      <div class="col-md-12 row" >
                        
                      <div class="col-md-4 row"> 
                       <div  class="col-md-3" ><mat-icon style="font-size: 38px;  padding: 5px 35px 35px 35px;">person</mat-icon></div>
                      <div class="col-md-9 d-flex justify-content-start"><strong>Client Name <br><span style="font-weight: 400;" class="d-flex justify-content-start">{{ pnrData?.clientName||'' }}</span></strong>
                      </div>
                      </div>
                      <div class="col-md-4 row"> 
                        <div  class="col-md-3" ><mat-icon style="font-size: 38px;  padding: 5px 35px 35px 35px;">work</mat-icon></div>
                        <div class="col-md-9  " style="text-align: left;"><strong>Trip Cart Id <br><span style="font-weight: 400;" >{{ pnrData?.orderId }}</span></strong>
                        </div>

                      </div>
                      <div class="col-md-4 row"> 

                        <div  class="col-md-3" ><mat-icon style="font-size: 38px;  padding: 5px 35px 35px 35px;">card_membership</mat-icon></div>
                        <div class="col-md-9 d-flex justify-content-start"><strong>Foreign Trip Id <br><span style="font-weight: 400;" class="d-flex justify-content-start">{{ '' }}</span></strong>
                        </div>
                      </div>


                        <!-- <p>Your PNR ({{pnrNo}}) has been successfully generated.</p> -->

                      </div> </div> 
                    
                    
                    </div>
                 
                    <div *ngIf="showNext && pnrData && currentStep===2" style=" height:40vh;overflow-y: auto; overflow-x:hidden; ">
                    <div   class="box-container mb-4" *ngFor="let itinerary of pnrData.invoiceItineraryList">
              
                      <div class="container ">
                        <div class="ticket-container" >
                          <div class="ticket-header" >
                            
                            <div class="row col-md-12 row">
                            <div class="d-flex justify-content-start col-md-6"><mat-icon> local_airport</mat-icon>{{itinerary?.fromCity}}-{{itinerary?.toCity}} <span style="background-color: brown;color:white; border-radius:2px;padding-right:3px;padding-left:3px ;margin-left: 10px;">{{itinerary?.invoiceFlightDetails[0]?.scheduleDepartureDay}}</span>
                           <div class="d-flex justify-content-center col-md-6">
                         <span style="padding-right: 10px;">GDS PNR </span>  <strong>{{ itinerary?.gdsPnr||'NA'}}</strong>
                           </div>
                            </div>
                          </div>
                          </div>
                          <div  *ngFor="let item of itinerary.invoiceFlightDetails">
                            <div class="col-md-12 row"> 
                              
                               
                        
                            <div class="col-md-3 mt-3"> <div class="col-md-12 ">
                             
                              <div class="col-md-12 d-flex justify-content-start">
                                <img  class="carrier-logo" [src]="flightlogoFilter(item?.carrierName)"  alt="">

                              
                                <strong style="padding-left: 4px;">{{fligthNameFilter(item?.carrierName)}}</strong></div>
                    
                              <div class="col-md-12  d-flex justify-content-start " style="padding-left: 28px;"> {{item?.carrierName }} - {{ item?.flightNumber }}</div>
                    
                            </div>
                            
                          </div>
                          <div class="col-md-9">

                            <div class="trip-details-container">
                              <div class="panel mt-3"  >
                                <!-- <div class=" flex flex-middle flex-between   row" style="background-color: #1876D1; border-radius: 4px;min-height:50px;color:white"> 
                                  <div class="col-md-4 "><div class="col-md-12 bold d-flex justify-content-start">{{item?.departureCity}}</div></div>
                                  <div class="col-md-4  d-flex justify-content-center "> <mat-icon class="mt-2">flight_takeoff</mat-icon></div>
                            
                                <div class="col-md-4   "><div class="col-md-12 bold d-flex justify-content-end">{{item?.arrivalCity}}</div></div>
                              </div> -->
                               
                            
                                <div  class="panel-content">
                                  <div class="flights " >
                            
                                   
                                  
                                    
                                  </div>
                            
                                  
                                </div>
                                <div class="col-md-12 row"> 
                                  
                                  <div class="col-md-4 "><div class="col-md-12  d-flex justify-content-start" style="font-size: 14px;">{{item?.scheduleDepartureDay}}</div><div class="col-md-12 bold d-flex justify-content-start">{{item?.departureCity}}</div><div class="col-md-12 d-flex justify-content-start">{{item?.scheduleDepartureTime }}</div><div class="col-md-12  d-flex justify-content-start" style="font-size: 14px;">{{item?.departureAirPort}}</div><div class="col-md-12 d-flex justify-content-start">{{item?.departureTerminal?("Terminal&nbsp;"+item?.departureTerminal):''}}</div></div>
                                  <div class="col-md-4  flight-number "><!-- ⌚ {{ "" }} -->

                                   <mat-icon class="mt-2">flight_takeoff</mat-icon>

                                  </div>
                            
                                <div class="col-md-4   "><div class="col-md-12  d-flex justify-content-end" style="font-size: 14px;">{{item?.scheduleArrivalDay}}</div><div class="col-md-12 bold d-flex justify-content-end">{{item?.arrivalCity}}</div><div class="col-md-12 d-flex justify-content-end">{{ item?.scheduleArrivalTime}}</div><div class="col-md-12  d-flex justify-content-end" style="font-size: 14px;">{{item?.arrivalAirPort}}</div><div class="col-md-12 d-flex justify-content-end">{{item?.arrivalTerminal?("Terminal&nbsp;"+item?.arrivalTerminal):''}}</div></div>
                              </div>
                                
                              </div>
                            
                              
                            
                              
                            </div>

                          </div>
                          <mat-divider></mat-divider>




                          





                    
                          </div>
                          <!-- <div class="ticket-passenger-details">
                            <h3>Passenger Details:</h3>
                            <ul>
                              <li *ngFor="let passenger of pnrData.passengerDetails">
                                {{ passenger?.passengerType }} - {{ passenger?.firstName }} {{ passenger?.lastName }}
                              </li>
                            </ul>
                          </div> -->
                          <div class="ticket-itinerary-details" >
              
                           

                              <div  >


              
                                
                              </div>
                            
                          </div>
                        </div>
                          


                        <div  *ngFor="let item of itinerary.itineraryPassengers">
                          <div class="col-md-12 row"> 
                            
                             
                      
                          <div class="col-md-3 mt-3"> <div class="col-md-12 ">
                           
                            <div class="col-md-12 d-flex justify-content-start">
                             <mat-icon>people</mat-icon>
                              <span style="padding-left: 4px;font-size: 14px;font-weight: bold;" >{{item?.title}} {{item?.firstName}} {{item?.lastName}}</span></div>
                  
                            <div class="col-md-12  d-flex justify-content-start " style="padding-left: 28px;"> {{item?.type==='ADT'?('Adult'):""}} {{item?.type==='CNN'?('Child'):""}} {{item?.type==='CHD'?('Child'):""}} {{item?.type==='INF'?('Infent'):""}}</div>
                  
                          </div>
                          
                        </div>
                        <div class="col-md-9">

                          <div class="trip-details-container">
                            <div class="panel mt-3"  >
                              <!-- <div class=" flex flex-middle flex-between   row" style="background-color: #1876D1; border-radius: 4px;min-height:50px;color:white"> 
                                <div class="col-md-4 "><div class="col-md-12 bold d-flex justify-content-start">{{item?.departureCity}}</div></div>
                                <div class="col-md-4  d-flex justify-content-center "> <mat-icon class="mt-2">flight_takeoff</mat-icon></div>
                          
                              <div class="col-md-4   "><div class="col-md-12 bold d-flex justify-content-end">{{item?.arrivalCity}}</div></div>
                            </div> -->
                             
                          
                              <div  class="panel-content">
                                <div class="flights " >
                          
                                 
                                
                                  
                                </div>
                          
                                
                              </div>
                              <div class="col-md-12 row"> 
                                
                                <div class="col-md-4 ">
                                  <div class="col-md-12 bold d-flex justify-content-start" style="font-size: 16px;">{{item?.pnr}}</div>
                                  <div class="col-md-12  d-flex justify-content-start" style="font-size: 14px;">Airline PNR</div>

                                <!-- <div class="col-md-12 mt-3 d-flex justify-content-start bold" style="font-size: 16px;">{{item?.totalPrice?(item?.totalPrice+' INR'):'' }} </div> -->
                                
                                <div class="col-md-12 mt-3 d-flex justify-content-start bold" style="font-size: 16px;">{{formatTotalPrice(item?.totalPrice) }} </div>

                                <div class="col-md-12  d-flex justify-content-start " style="font-size: 14px;">Total Price</div>

                              </div>
                                <div class="col-md-4  flight-number "><!-- ⌚ {{ "" }} -->

                                  <div class="col-md-12  d-flex justify-content-center bold" style="font-size: 16px;">{{item?.ticket==='0'?('N/A'):item?.ticket===0?('N/A'):item?.ticket===null?('N/A'):item?.ticket}}</div>
                                  <div class="col-md-12 d-flex justify-content-center " style="font-size: 14px;">Ticket No</div>

                                </div>
                          
                              <div class="col-md-4   ">
                                <div class="col-md-12  d-flex justify-content-end bold" style="font-size: 16px;">{{item?.bookingClass}}</div>
                                <div class="col-md-12 d-flex justify-content-end " style="font-size: 14px;">Class</div>

                              </div>
                            </div>
                              
                            </div>
                          
                            
                          
                            
                          </div>

                        </div>
                        <mat-divider></mat-divider>




                        





                  
                        </div>
                        <!-- <div class="ticket-passenger-details">
                          <h3>Passenger Details:</h3>
                          <ul>
                            <li *ngFor="let passenger of pnrData.passengerDetails">
                              {{ passenger?.passengerType }} - {{ passenger?.firstName }} {{ passenger?.lastName }}
                            </li>
                          </ul>
                        </div> -->
                        <div class="ticket-itinerary-details" >
            
                         

                            <div  >


            
                              
                            </div>
                          
                        </div>
                      </div>





                        </div></div>
              </div>
              
              </div>
              
                  <div *ngIf="!showNext" class="box-container ">
              
                      <div class="container">
              
                <div class="title">
                    <div class="row">
                     <div class=" col-md-2  " ><div class="pointer d-flex justify-content-start "   style="padding-left:20px;"></div></div>  
                    <div class="col-md-7 d-flex justify-content-center">Payment Details</div>
                    <div class=" col-md-3 row ">
                      <div class="d-flex justify-content-end">
                      <button class="btn btn-outline-primary btn-sm "(click)="onClickGstInfo()" >GST Information
                        <img src="assets/images/Add_24.png"></button>
                    </div>
                     </div>
                   </div>
                  </div>
                  <div *ngIf="showGstInfo" class="row mt-3" >
                    <mat-form-field class="col-md-3" appearance="outline">
                      <mat-label>GST Number</mat-label>
                      <input matInput type="text"  readonly  name="gstNumber" [ngModel]="billingEntity?.entityGST" autocomplete="off" >
  
                    </mat-form-field> 
                    <mat-form-field class="col-md-3" appearance="outline">
                      <mat-label>GST Name</mat-label>
                      <input matInput type="text" readonly  name="gstName" [ngModel]="billingEntity?.gstName" autocomplete="off" >
  
                    </mat-form-field>  
                    <mat-form-field class="col-md-3" appearance="outline">
                      <mat-label>GST Email</mat-label>
                      <input matInput type="text"  [ngModel]="billingEntity?.email" readonly name="gstEmail" autocomplete="off" >
  
                    </mat-form-field>
                    <mat-form-field class="col-md-3" appearance="outline">
                      <mat-label>GST Phone No.</mat-label>
                      <input matInput type="text" (keypress)="onlyNumberKey($event)" [ngModel]="billingEntity?.phone" readonly name="gstPhone" autocomplete="off" >
  
                    </mat-form-field>   
                  </div>
              <div class="col-md-12 row">
              <div class="payment-options col-md-9">
              
              <mat-selection-list   [multiple]="false"  #PaymentType   (selectionChange)="OrderId()">
                <span *ngFor="let medium of orderId.paymentConfig.status" >
              <mat-list-option *ngIf="medium.isBusinessEnabled&&medium.mediumName!='PG'" isBusinessEnabled [color]="'primary'"   [value]="medium.mediumName" 
              checkboxPosition="before"><span >{{medium.mediumName}}</span>&nbsp;&nbsp;<mat-icon *ngIf="medium.mediumName!='VIRTUAL_CARD'&&medium.mediumName!='MOTO'" style="padding-top: 4px; margin-left: 10px;"  matTooltipPosition="above" (mouseenter)="GetBalance()" class="pointer"
                [matTooltip]="medium.mediumName==='DEPOSIT'?(totalBalance?.totalDepositAmount?(totalBalance?.totalDepositAmount+' INR'):'N/A'):medium.mediumName==='CREDIT'?(totalBalance?.totalCreditAmount?(totalBalance?.totalCreditAmount+' INR'):'N/A'):'N/A'"
                matTooltipHideDelay="100" matTooltipHideDelay="0">remove_red_eye</mat-icon>

              </mat-list-option>
              <div *ngIf="medium.isBusinessEnabled&&medium.mediumName==='MOTO'" style="font-size: 14px;">Platform Charges will be debited from Below Card</div>

              <div *ngIf="medium.isBusinessEnabled&&medium.mediumName!='PG'&&medium.mediumName!='MOTO'" style="font-size: 14px;">The cost of this ticket will be charged to your company account maintained with us.</div>

            </span>
              <!-- <mat-list-option    value="credit"   [color]="'primary'" checkboxPosition="before"><span (click)="openTooltip()" >Credit</span>&nbsp;&nbsp;&nbsp;&nbsp;<mat-icon style="padding-top: 4px;margin-left:10px" matTooltipPosition="above" (mouseenter)="GetBalance()"  [matTooltip]="totalBalance?.totalCreditAmount?(totalBalance?.totalCreditAmount +' INR'):'0 INR'"
                matTooltipHideDelay="100" matTooltipHideDelay="0" class="pointer">remove_red_eye</mat-icon>
              </mat-list-option>
            <span style="font-size: 14px;"> The cost of this ticket will be charged to your company account maintained with us.</span>
            <mat-list-option    value="card"   [color]="'primary'" checkboxPosition="before"><span (click)="openTooltip()" >Card</span>&nbsp;&nbsp;&nbsp;&nbsp;<mat-icon style="padding-top: 4px;margin-left:10px" matTooltipPosition="above" (mouseenter)="GetBalance()"  [matTooltip]="totalBalance?.totalCreditAmount?(totalBalance?.totalCreditAmount +' INR'):'0 INR'"
              matTooltipHideDelay="100" matTooltipHideDelay="0" class="pointer">remove_red_eye</mat-icon>
            </mat-list-option>
          <span style="font-size: 14px;"> The cost of this ticket will be charged to your company account maintained with us.</span> -->
            <div class="row">

           
              <mat-form-field *ngIf="fopType==='VIRTUAL_CARD'" class=" required col-md-12 form-group mt-2" appearance="outline">
                <mat-label>Cards</mat-label>
                <mat-select   matNativeControl name="card" [(ngModel)]="cardNo"  (selectionChange)="cardData($event)"  >
                  <mat-option *ngFor="let item of CreditData" [value]="item.cardUuid"   >{{item?.maskedCardNumber}}</mat-option>
                </mat-select>
                </mat-form-field>
                <mat-form-field *ngIf="fopType==='MOTO'" class=" required col-md-12 form-group mt-2" appearance="outline">
                  <mat-label>Cards</mat-label>
                  <mat-select   matNativeControl name="card" [(ngModel)]="cardNo"  (selectionChange)="cardData($event)"  >
                    <mat-option *ngFor="let item of CreditData" [value]="item.cardUuid"   >{{item?.maskedCardNumber}}</mat-option>
                  </mat-select>
                  </mat-form-field>


              </div>
              </mat-selection-list> 
              </div>
              <div class="payment-options col-md-3" >
                <div class="title bold" style="font-size: 15px;text-align: center;">Ticket Issuance</div>

                <mat-selection-list #ticketIssuance   [multiple]="false"  (selectionChange)="OrderId()" >
                <mat-list-option checkboxPosition="before"  [color]="'primary'"   value="false" ><span >HOLD</span></mat-list-option>
                <mat-list-option checkboxPosition="before"  [color]="'primary'"   value="true" ><span >ISSUE</span> </mat-list-option>
              </mat-selection-list>
              </div>
            <div  class="col-md-11" >
          
              <div class="title bold" style="font-size: 15px;">Pass-Through Detail</div>
              <table class="styled-tables" style="font-size: 15px;">
                <thead>
                  <th class="name-type">Segment</th>
                  <th class="name-type">Medium </th>
                  <th class="name-type"> Fare Amount</th>
                  <th class="name-type"> Seat Amount</th>
                  <th class="name-type"> Meal Amount</th>
                  <th class="name-type"> Total Amount</th>

                </thead>
                <tbody>
                  
                  <tr *ngFor="let item of orderId.passThroughInfo">
                    <!-- Display structured data -->
                    <td   style="padding: 8px;">{{item?.segment||''}}</td>
                    <td  style="padding: 8px;">{{item?.updatedPaymentMedium==='R'?('CARD'):''}}{{item?.updatedPaymentMedium==='C'?('CASH'):''}}</td>
                    <td  style="padding: 8px;">{{item?.baseTaxFare?(item?.baseTaxFare+' INR'):''}}</td>
                    <td  style="padding: 8px;">{{item?.seatCharges?(item?.seatCharges+' INR'):0}}</td>
                    <td  style="padding: 8px;">{{item?.mealCharges?(item?.mealCharges+' INR'):0}}</td>

                    <td  style="padding: 8px;">{{item?.totalAmount?(item?.totalAmount+' INR'):''}}</td>

                  </tr>
                 
                </tbody>
              </table>


              <table *ngIf="loginUserType==='STAFF'&&checkCardInPassThrough()" class="styled-tables" style="font-size: 15px;">
                <thead>
                  

                </thead>
                <tbody>
                  
                  <tr >
                  <th class="name-type">Root Passthrough Payment?</th>
                  <td   style="padding: 8px;">
                    <mat-selection-list   [multiple]="false" #PassthroughPayment (selectionChange)="onPassthroughChange()"   style="display: flex;
                    flex-direction: row;
                    gap: 16px; " >
                    <mat-list-option   [color]="'primary'" [value]="'default'"  checkboxPosition="before"><span >Default</span> </mat-list-option>
                    <mat-list-option   [color]="'primary'" [value]="'enable'"  checkboxPosition="before"><span >Enable</span> </mat-list-option>
                    <mat-list-option   [color]="'primary'" [value]="'disable'" checkboxPosition="before"><span >Disable</span> </mat-list-option>
      
                    </mat-selection-list>
                  </td>
                 
                  </tr>
                  <tr *ngIf="CreditEnable==='enable'">
                    <th class="name-type">Select a credit card </th>
                    <td   style="padding: 8px;">
                      <div  style="font-size: 14px;text-align: start">Supplier Charges (Passthrough) will be debited from below card</div>

                      <mat-form-field  class=" required col-md-12 form-group mt-2" appearance="outline">
                        <mat-label>Cards</mat-label>
                        <mat-select   matNativeControl name="card" [(ngModel)]="cardPassThroughNo"  (selectionChange)="orderSelectionUpdate()"  >
                          <mat-option *ngFor="let item of PassThroughCardList" [value]="item.cardUuid"   >{{item?.card}}</mat-option>
                        </mat-select>
                        </mat-form-field>
                    </td>
                   
                    </tr>
                    <tr *ngIf="CreditEnable==='default'">
                      <th class="name-type">Matched card </th>
                      <td   style="padding: 8px;text-align: start;">
                       {{getFilteredCards()}}
                       <!-- <span *ngFor="let item of PassThroughCardList" >
                        <span *ngIf="item.status==='M'">{{item?.card}}</span>
                       </span> -->
                      </td>
                     
                      </tr>
                 
                </tbody>
              </table>
            
            </div>

              <div class="mt-3 mb-2   col-md-3">
                <!-- <mat-selection-list   [multiple]="true" (click)="onClickPricing()"  [(ngModel)]="advancePricing"  >
                  <mat-list-option [color]="'primary'"    value="advancePricing" 
                  checkboxPosition="before">
                  Advanced Pricing
                </mat-list-option>
                </mat-selection-list> -->
              <!--<div  class="col-md-12 d-flex justify-content-center bold"> 
                <input type="checkbox" (click)="onClickPricing()" >Advanced Pricing
              </div>
                <table *ngIf="showadvancePrice" class="styled-tables col-md-12">
                  <thead>
                    <tr >-->
                      <!-- Dynamic headers based on tableHeaders array -->
                     <!-- <th style="padding: 8px;  text-align: center;">Base		</th>
                      <th style="padding: 8px;  text-align: center;">Tax	</th>
                      <th style="padding: 8px;  text-align: center;">Fee	</th>



                    </tr>
                  </thead>
                  <tbody>-->
                    <!-- Iterate through dynamic data rows -->
                    <!--<tr >
                     
                      <td  style="padding: 8px;">{{''}}</td>
                      <td  style="padding: 8px;">{{''}}</td>
                      <td  style="padding: 8px;">{{''}}</td>
                    

                    </tr>
                  </tbody>
                </table>-->



              <!-- <div class="col-md-12 mb-4 row">
              <div class="col-md-8 mt-2 d-flex justify-content-start">Convenience Fee</div>
              <div class="col-md-4 mt-2 d-flex justify-content-start"></div>
              <div class="col-md-8 mt-2 d-flex justify-content-start"></div>
              <div class="col-md-4 mt-2 d-flex justify-content-start"></div>
              
              </div>
                <mat-divider></mat-divider>
                <div class="col-md-12 mb-4 row">
                    <div class="col-md-8 mt-2 d-flex justify-content-start">Total Price</div>
                    <div class="col-md-4 mt-2 d-flex justify-content-start"></div>
                    
                
                   </div> -->
              </div>
              </div>
              
              
              </div>
              </div>
              
              <div *ngIf="!showNext" class=" mt-4 box-container ">
              <div class="container">
              
              <div  class="terms-and-conditions">
              <h4>Terms and Conditions</h4>
              <li>Meal Request, Seat Request, Special Request,Baggage Request or Frequent Flier are not guaranteed</li>
              <li>Fares and Seats are subject to availability and might not be available by the time you submit the booking request</li>
              <div class="d-flex justify-content-start">

              <mat-checkbox *ngIf="acceptTerm==='false'"          
                (click)="termConditions('true')" [color]="'primary'" >
                I have read and accepted the above mentioned terms and the Terms of Service</mat-checkbox>
                <mat-checkbox *ngIf="acceptFTerm==='true'"  [(ngModel)]="acceptTerm" [ngModelOptions]="{standalone: true}" (click)="termConditions('false')" [color]="'primary'" >
                  I have read and accepted the above mentioned terms and the Terms of Service</mat-checkbox>
              </div>
                
              
              </div>
              </div>
              </div>
              <mat-divider class="mt-3 mb-3"></mat-divider>
              <div  *ngIf="showNext" class="ticket-footer">
                <div class="row">
                  <div class="col-md-7 d-flex justify-content-end">
                <button   mat-raised-button color="#ffffff" style="margin-right: 8px;" (click)="print()">
                  <mat-icon>print</mat-icon>Print</button>
                   <button   mat-raised-button color="#ffffff" style="margin-right: 8px;" (click)="download()" >
                    <mat-icon>download</mat-icon>Download</button>
                  </div>
                  <div class="col-md-5 d-flex justify-content-end">

                    <button   mat-raised-button color="#ffffff" style="margin-right: 8px;"(click)="backFlight()">
                      <mat-icon>arrow_back</mat-icon>Back</button>
                    </div>

                    </div>
              </div>
                  <div  class="d-flex justify-content-end">
              
              <!-- <button *ngIf="!showNext"  mat-raised-button color="accent" style="margin-right: 8px;" (click)="backClick()">
              
              <mat-icon>arrow_back</mat-icon>Back
               </button> -->

              <span *ngIf="!showNext">
                <button  *ngIf="!showSpiner && fopType==='VIRTUAL_CARD'||!showSpiner && fopType==='MOTO'" mat-raised-button color="accent" (click)="verifyData()" [disabled]="acceptTerm==='false'||!cardNo"> Book Flights</button>

                <button  *ngIf="!showSpiner && fopType!='VIRTUAL_CARD&&fopType!='MOTO''" mat-raised-button color="accent" (click)="verifyData()" [disabled]="acceptTerm==='false'"> Book Flights</button>

               <!-- <button  *ngIf="!showSpiner" mat-raised-button color="accent" (click)="booking()" [disabled]="acceptTerm==='false'"> Book Flights</button> -->
               <button  *ngIf="showSpiner"  mat-raised-button color="accent" style="margin-right: 2%; width: 100px;"  ><mat-spinner  diameter="30" ></mat-spinner></button>
              </span>
            
              
              <!-- <span *ngIf="!pnrData">
              <button  *ngIf="showNext && !showMore" mat-raised-button color="accent"   (click)="pnrRetreive()"> More Details</button></span>
              <button  *ngIf="showMore"  mat-raised-button color="accent" style="margin-right: 2%; width: 100px;"  ><mat-spinner  diameter="30" ></mat-spinner></button>
               -->
                  </div>
                </form>
                         
              
                          </div>
            </div>
          
            <!-- <div class="buttons">
              <button (click)="prevStep()" class="dbutton" [disabled]="currentStep === 1">Previous</button>
              <button (click)="nextStep()"  class="dbutton" [disabled]="currentStep === 3">Next</button>
            </div> -->
          </div>
        </div>
      </div>
    </div>

          <div *ngIf="test">
            <!-- <app-test></app-test> -->
          </div>
          
          <!-- <p-button (click)="showDialog()" label="Show" /> -->
         


          <p-dialog header="Booking Details" [modal]="true" [(visible)]="verifyShow" [style]="{ width: '50rem' }">
            <div *ngIf="bookingRequest" class="booking-details">
              <div class="section ">
                <div class="col-md-12 row">
                <h5>Passenger Count</h5>
                </div>
                <div class="col-md-12 row">
                <p class="col-md-4 ">Adults: {{bookingRequest?.adultCount}}</p>
                <p class="col-md-4 ">Children: {{bookingRequest?.childCount}}</p>
                <p class="col-md-4 ">Infants: {{bookingRequest?.infantCount}}</p>
              </div>
              </div>
            
              <div  class="section">
                <div class="col-md-12 row">
                <h5 >Passenger Details</h5>
                </div>
                <div *ngFor="let passenger of bookingRequest.passengerDetails;let i=index">
                  <div class="col-md-12 row">

                  <p style="background-color: rgb(34, 160, 238); color: white;"><span  style="font-weight: bold;font-size: 23px;"> Passenger </span> <strong style="font-size: 23px;">.{{i+1}} {{passenger?.passengerType||''}}</strong> <span style="font-weight: bold;font-size: 23px; position: relative; left: 10%;;"> {{passenger?.passengerTitle}} {{passenger?.firstName}} {{passenger?.lastName}}</span></p>
</div>
                 <div class="col-md-12 row">
                 <!-- <p class="col-md-4"><strong>Name :</strong> {{passenger?.passengerTitle}} {{passenger?.firstName}} {{passenger?.lastName}}</p> -->
                  <!-- <p class="col-md-4"><strong>Type :</strong> {{passenger?.passengerType||'-'}}</p> -->
                  <p class="col-md-6"><strong>Email :</strong> {{passenger?.email||'-'}}</p>
                  <p class="col-md-6"><strong>Mobile :</strong> {{passenger?.mobile||'-'}}</p>
                </div>
                <div class="col-md-12 row">

                <p style="background-color: grey; color: white;cursor: pointer;" (click)="passenger.click=!passenger.click"><span  style="font-weight: bold;font-size: 18px;">Reporting Details</span> <span style="position: relative; left: 75%; margin-top: 18px;"><mat-icon *ngIf="!passenger.click"  >keyboard_arrow_down</mat-icon><mat-icon  *ngIf="passenger.click===true" >keyboard_arrow_up</mat-icon></span></p>
                
                </div>
                <div class="col-md-12 row">
                  <div  class="col-md-6 " *ngFor="let tag of passenger.reportingTags">
                    <p *ngIf="passenger.click===true" class="col-md-12">
                      {{tag?.displayName}}:
                      <span *ngIf="tag.value.includes('base64')">
                        {{matchbase64(tag?.value)}}
                      </span>
                      <span *ngIf="!tag.value.includes('base64')">
                        {{tag?.value}}
                      </span>
                    </p>
                  </div>
                </div>
                  <div *ngFor="let seat of passenger.seatMeal">
                    <div class="col-md-12 row">

                    <p style="background-color: rgb(76, 112, 135); color: white;"><span  style="font-weight: bold;font-size: 18px;">{{seat?.from}} - {{seat?.to}} </span> </p>
</div>
                    <!-- <p>From: {{seat?.from||'-'}}</p>
                    <p>To: {{seat?.to||'-'}}</p> -->
                    <div class="col-md-12 row">
                    <p class="col-md-6 "><strong>Seat Number :</strong> {{seat?.seatNumber||'-'}}</p>
                    <p class="col-md-6 "><strong>Meal Preferences :</strong> {{seat?.mealPreferences||'-'}}</p>
                  </div>
                  </div>
                </div>
              </div>
            
              <div class="section">
                <div class="col-md-12 row">
                <h5>Contact Details</h5>
                </div>
                <div class="col-md-12 row">

                <p class="col-md-6 "><strong>Contact Number:</strong> {{bookingRequest?.contactNumber||'-'}}</p>
                <p class="col-md-6 "><strong>Email:</strong> {{bookingRequest?.email||'-'}}</p>
                </div>
              </div>
            
              <div class="section">
                <div class="col-md-12 row">
                <h5>GST Details</h5>
                </div>
                <div class="col-md-12 row">
                <p class="col-md-6 "><strong>GST Number :</strong> {{bookingRequest?.gstNumber||'-'}}</p>
                <p class="col-md-6 "><strong>GST Email :</strong> {{bookingRequest?.gstEmail||'-'}}</p>
                <p class="col-md-12 "><strong>GST Name :</strong> {{billingEntity?.gstName||'-'}}</p>
              </div>

              </div>
            
              <div class="section">
                <div class="col-md-12 row">
                <h5>Advance Pricing</h5>
                </div>
                <div *ngFor="let markup of bookingRequest.runtimeMarkUp">

                  <div *ngFor="let pricing of markup.advancedPricingList;let i=index">
<div class="col-md-12 row">
                    <p style="background-color: rgb(34, 160, 238); color: white;"><span  style="font-weight: bold;font-size: 18px;">{{markup?.fromAirport}} - {{markup?.toAirport}} {{pricing?.passengerType||'-'}} </span> <strong style="font-size: 18px;">.{{i+1}}</strong> </p>
                  </div>
                    <div class="col-md-12 row">
                    <p class="col-md-4 "><strong>Fee Amount :</strong> {{pricing?.feeAmt}}</p>
                    <p class="col-md-4 "><strong>Base Amount :</strong> {{pricing?.baseAmt}}</p>
                    <p class="col-md-4 "><strong>Tax Amount :</strong> {{pricing?.taxAmt}}</p>
                  </div>
                  </div>
                </div>
              </div>
            </div>
            
          <ng-template pTemplate="footer">
            <div class="flex justify-content-end gap-2 mt-3">
              
              <p-button label="Cancel" severity="secondary" (click)="verifyShow = false" />
              &nbsp;
              <p-button  label="BOOK" (click)="booking();verifyShow = false" />
            
          </div>
          </ng-template>
        </p-dialog>



        <p-dialog   [modal]="true" [maximizable]="true" [(visible)]="ShowDuplicateBookings" [style]="{ width: '80%' }">
          <ng-template pTemplate="header">
           <h4 style="color: red; ">Duplicate Booking</h4> 
          </ng-template>
          
        <div class="table-container">
          <div *ngFor="let sector of getKeys(duplicateBookingList)">
            <h3 class="mt-2">{{ sector }}</h3>
            <table class="styled-tables">
              <thead>
                <tr>
                  <th><span class="marginleft">Passenger Type</span></th>
                  <th><span class="marginleft">First Name</span></th>
                  <th><span class="marginleft">Last Name</span></th>
                  <th  ><span class="marginleft">Cart UUID </span></th>
                  <th><span class="marginleft">PNR Number</span></th>
                  <th><span class="marginleft">Ticket Number</span></th>
                  <th><span class="marginleft">First Departure Time</span></th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let flight of duplicateBookingList[sector]">
                  <td ><span class="marginleft">{{ flight.passengerType }} </span></td>
                  <td ><span class="marginleft">{{ flight.firstName }}</span></td>
                  <td ><span class="marginleft">{{ flight.lastName }}</span></td>
                  <td  ><span class="marginleft"  style="color: rgb(0, 115, 255);cursor: pointer;" (click)="onModifyClick(flight.cartUuid)">{{ flight.cartUuid }}</span></td>
                  <td > <span class="marginleft">{{ flight.pnrNumber || 'N/A' }}</span></td>
                  <td ><span class="marginleft">{{ flight.ticketNumber || 'N/A' }}</span></td>
                  <td ><span class="marginleft">{{ flight.firstDepartureTime || 'N/A' }}</span></td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <ng-template pTemplate="footer">
          <div class="flex justify-content-end gap-2 mt-3">
            
            <!-- <p-button label="Cancel" severity="secondary" (click)="ShowDuplicateBookings = false" />
            &nbsp; -->
            <p-button  label="Accept" (click)="accept_cancel('Accept')" />&nbsp;
            <p-button  label="Back to Search" (click)="accept_cancel('Cancel')"   />

        </div>
        </ng-template>
      </p-dialog>

         
            
            

        
           
